export const replacer = (str: string, variables: Record<string, string>, defaultValue?: string) => {
    return str.replace(/\{\{([\w.]*)\}\}/g, (match, p1) => {
        const value = variables[p1] || defaultValue
        if (value) {
            return match.replace(match, value)
        }
        return match
    })
}